export default {
  init() {
    // JavaScript to be fired on the about us page
    $(document).ready(function () {
      let companyId = $('#js-application-company-name').attr('data-company-id').trim();
      let companyName = $('#js-application-company-name').text().trim();
      let recruitmentName = $('#js-application-recruitment-name').text().trim();
      let typeOfEmployment = $('#js-application-type-of-employment').text().trim();
      $('#js-field-company-id').val(companyId);
      $('#js-field-company-name').val(companyName);
      $('#js-field-recruitment-name').val(recruitmentName);
      $('#js-field-type-of-employment').val(typeOfEmployment);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/application.js